import { Container, FunctionAction } from '@cgs/wge';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';

export class EndBonusGameComponent {
  constructor(container: Container) {
    const gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    gameStateMachine.endBonus.appendLazyAnimation(
      () =>
        new FunctionAction(() => {
          gameStateMachine.resume();
        })
    );
    gameStateMachine.endScatter.appendLazyAnimation(
      () =>
        new FunctionAction(() => {
          gameStateMachine.resume();
        })
    );
  }
}
